import { useState, useEffect, useCallback } from 'react'
import { localStorageHelper } from '../../../../../utils/localStorageHelper'

const STORAGE_KEY = 'queryTool.panelSizes'

export function useResizablePanels (defaultSizes = {
  utilityWidth: 250,
  editorHeight: 50 // percentage
}) {
  const [sizes, setSizes] = useState(() => {
    return localStorageHelper.loadOrDefault(STORAGE_KEY, defaultSizes)
  })

  // Save to localStorage whenever sizes change
  useEffect(() => {
    localStorageHelper.tryStore(STORAGE_KEY, sizes)
  }, [sizes])

  const setUtilityWidth = useCallback((width) => {
    setSizes(prev => ({ ...prev, utilityWidth: width }))
  }, [])

  const setEditorHeight = useCallback((height) => {
    setSizes(prev => ({ ...prev, editorHeight: height }))
  }, [])

  const resetSizes = useCallback(() => {
    setSizes(defaultSizes)
    localStorageHelper.tryRemove(STORAGE_KEY)
  }, [defaultSizes])

  return {
    sizes,
    setUtilityWidth,
    setEditorHeight,
    resetSizes
  }
}

export default useResizablePanels
